import { render, staticRenderFns } from "./VariableTextarea.vue?vue&type=template&id=1c7a1e4b&"
import script from "./VariableTextarea.vue?vue&type=script&lang=js&"
export * from "./VariableTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/code/element_parking/assets/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VTextarea})
